var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8564 2.15007C13.9029 2.19651 13.9399 2.25169 13.9651 2.31243C13.9903 2.37318 14.0033 2.4383 14.0033 2.50407C14.0033 2.56983 13.9903 2.63496 13.9651 2.6957C13.9399 2.75645 13.9029 2.81162 13.8564 2.85807L2.85636 13.8581C2.76247 13.952 2.63513 14.0047 2.50236 14.0047C2.36958 14.0047 2.24225 13.952 2.14836 13.8581C2.05447 13.7642 2.00173 13.6368 2.00173 13.5041C2.00173 13.3713 2.05447 13.244 2.14836 13.1501L13.1484 2.15007C13.1948 2.1035 13.25 2.06656 13.3107 2.04136C13.3715 2.01615 13.4366 2.00317 13.5024 2.00317C13.5681 2.00317 13.6332 2.01615 13.694 2.04136C13.7547 2.06656 13.8099 2.1035 13.8564 2.15007Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14836 2.15007C2.1018 2.19651 2.06485 2.25169 2.03965 2.31243C2.01444 2.37318 2.00146 2.4383 2.00146 2.50407C2.00146 2.56983 2.01444 2.63496 2.03965 2.6957C2.06485 2.75645 2.1018 2.81162 2.14836 2.85807L13.1484 13.8581C13.2422 13.952 13.3696 14.0047 13.5024 14.0047C13.6351 14.0047 13.7625 13.952 13.8564 13.8581C13.9502 13.7642 14.003 13.6368 14.003 13.5041C14.003 13.3713 13.9502 13.244 13.8564 13.1501L2.85636 2.15007C2.80991 2.1035 2.75474 2.06656 2.69399 2.04136C2.63325 2.01615 2.56813 2.00317 2.50236 2.00317C2.43659 2.00317 2.37147 2.01615 2.31072 2.04136C2.24998 2.06656 2.1948 2.1035 2.14836 2.15007Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.a1c9122c44e648e341cc57882c175faf.svg";
export { ForwardRef as ReactComponent };